import React from 'react';
import { Chip } from '@mui/material';
import { Text, Theme, i18n, tokens } from '@simplybenefits/sb-ui-library';
import UsageBlock from './UsageBlock.js';
import Tooltip from "@mui/material/Tooltip";
import { helpers } from "@simplybenefits/sb-utils";
import { Info as InfoIcon } from "@mui/icons-material";

/**
 * @param usage
 * @param coverage
 * @param fillColor
 * @param waivedEHC
 * @returns {JSX.Element}
 * @constructor
 */
const VisionUsageBlock = ({ usage, coverage, fillColor, waivedEHC }) => (
    <React.Fragment>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
            <div style={{ marginTop: 20 }}>
                <Text
                    medium
                    bold
                    customStyle={{
                        flex: 1,
                        display: 'inline',
                        margin: '0 0 10px 0'
                    }}
                >
                    { i18n.t(tokens.titles.vision) }
                </Text>

                {
                    waivedEHC &&
                        <Chip
                            size="small"
                            label="Waived"
                            color="primary"
                            variant="outlined"
                            style={{
                                margin: "5px 10px",
                                borderRadius: 30,
                                borderWidth: 2,
                                borderColor: Theme.colors.lightGrey,
                                fontFamily: Theme.fonts.type.heading,
                                fontSize: 14,
                                color: '#666'
                            }}
                        />
                }
            </div>

            {
                usage.isCombinedMaximum ?
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <Tooltip
                                title={ i18n.t(tokens.labels.coverage.visionServicesSpendAmount, { amount: helpers.numberWithCommasDecimals(usage.combinedMax - usage.totalUsed) })}
                                arrow
                                placement="top"
                            >
                                <InfoIcon aria-label="info" style={{ fontSize: 15, color: Theme.colors.mediumGrey, marginRight: 10 }} />
                            </Tooltip>

                            <Text small bold>
                                { i18n.t(tokens.labels.coverage.combinedMaximumCombinedmax, { combinedMax: helpers.numberWithCommasDecimals(usage.combinedMax) }) }
                            </Text>
                        </div>

                        <Text small bold margin="0 0 10px 0" align="right">
                            { i18n.t(tokens.labels.amountRemaining, { amount: helpers.numberWithCommasDecimals(usage.combinedMax - usage.totalUsed) })}
                        </Text>
                    </div>
                    :
                    null
            }
        </div>

        {
            usage.used.map((item) => {
                if (coverage[item.coverageColumn]) {
                    return (
                        <UsageBlock
                            key={ item.type }
                            usage={{
                                type: item.type,
                                limit: coverage[item.coverageColumn],
                                used: item.used
                            }}
                            fillColor={ fillColor }
                            showRemaining={ !usage.isCombinedMaximum }
                        />
                    );
                }

                return null;
            })
        }

        {
            usage.unused.map((item) => {
                if (coverage[item.coverageColumn]) {
                    return (
                        <UsageBlock
                            key={ item.type }
                            usage={{
                                type: item.type,
                                limit: coverage[item.coverageColumn],
                                used: item.used
                            }}
                            fillColor={ fillColor }
                        />
                    );
                }

                return null;
            })
        }
    </React.Fragment>
);

export default VisionUsageBlock;